import { Fragment } from "react"

import { Heading } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

import { faqs } from "../resources"

import Accordion from "./accordion"

const FAQs = () => (
  <Fragment>
    <Heading
      as="h3"
      mt={6}
      mb={4}
      sx={{
        lineHeight: "body",
        variant: "vwo.heading",
        textAlign: [null, "center"],
      }}
    >
      <Trans i18nKey="ChoosePlan.Faqs.title" />
    </Heading>
    {faqs.map(({ icon, question, answer }, index) => (
      <Accordion key={index} icon={icon} title={question}>
        {answer}
      </Accordion>
    ))}
  </Fragment>
)

export default FAQs
